import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../styles/pages/profile/ProfilePage.module.css";

const SettingsFormSkeleton = () => {
  return (
    <div className={styles.settingsContainer}>
      <div className={styles.settingsHeader}>
        <Skeleton height={32} width="250px" style={{ marginBottom: "10px" }} />
        <Skeleton height={18} width="300px" />
      </div>

      <div className={styles.settingsForm}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            style={{
              border: "1px solid var(--color-border)",
              borderRadius: "var(--radius-md)",
              overflow: "hidden",
            }}
          >
            <div style={{ padding: "16px 24px" }}>
              <Skeleton height={22} width="220px" style={{ marginBottom: "8px" }} />
              <Skeleton height={16} width="320px" />
            </div>
          </div>
        ))}

        <div className={styles.formActions}>
          <Skeleton height={44} width="150px" borderRadius={8} />
        </div>
      </div>
    </div>
  );
};

export default SettingsFormSkeleton;
